import {CostCategory} from 'types/cost-category';

export const costCategories = [
  'components',
  'development',
  'logistic',
  'other',
] as CostCategory[];
